import { observer } from "mobx-react-lite";
import React from "react";
import styles from "./AttrLinked.module.less";
import { AttrLinkedStore } from "./AttrLinkedStore";

/**
 * Выводит значения связанного атрибута. Согласно договорённости с Максом,
 * пока что выводим "сырые" значения простых типов без учета их настроек.
 * Остальная доработка будет в след. спринте
 */
type PropsAttrLinked = {
  store: AttrLinkedStore | null;
};

export const AttrLinked: React.FC<PropsAttrLinked> = observer(({ store }) => {
  if (!store) return null;
  return <div className={styles.linkList}>{store.label}</div>;
});
